module.exports = __webpack_public_path__ + "static/media/events.7c002520.gif";